import api from "@/frontend/api";

export default {
    create: params => api.post('works-for-sales', params),
}